import Icon, {IconProps} from 'components/Icon';
import {COLOR, Color} from 'components/IconColor/types';
import TooltipWrapper from 'components/Tooltip';
import {useTooltip} from 'components/Tooltip/hook';
import {TooltipType} from 'components/Tooltip/types';
import {LayoutMethod} from 'hooks/useComponentPosition/types';
import {FC, HTMLAttributes} from 'react';
import {twMerge} from 'tailwind-merge';

type DownloadIconProps = {
    color?: Color;
    href: string;
};

type DownloadLinkProps = {
    color?: Color;
    href: string;
    message?: string;
    tooltipLayout?: LayoutMethod;
    tooltipType?: TooltipType;
} & HTMLAttributes<HTMLDivElement> &
    Partial<IconProps>;

const DownloadIcon: FC<DownloadIconProps & HTMLAttributes<HTMLDivElement>> = ({
    children,
    className,
    color = 'black',
    href,
}) => {
    const {setTooltipRef} = useTooltip();

    return (
        <a
            download={true}
            href={href}
            ref={(r) => setTooltipRef(r)}
            rel="noreferrer"
            target="_blank"
        >
            {children}
            <Icon
                className={twMerge(
                    'inline-block justify-center align-middle',
                    COLOR[color],
                    className,
                )}
                icon="download"
                size="base"
            />
        </a>
    );
};

const DownloadLink: FC<DownloadLinkProps> = ({
    className,
    color = 'black',
    href,
    message = '',
    ...rest
}) => (
    <TooltipWrapper message={message}>
        <DownloadIcon
            className={className}
            color={color}
            href={href}
            {...rest}
        />
    </TooltipWrapper>
);

export default DownloadLink;
